import { useEffect, useMemo, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";

import { db } from "~/db/db";
import prepareForOptions from "~services/utils/prepareForOptions";
import { getColumnIntoKey } from "~pages/PriceSearchV2/utils/initializerHelpers";

const usePesquisaGrupoMaterial = (formikRef) => {
  const pesquisaGrupoMaterialSelect = useSelect("pesquisaGrupoMateriais");
  const [pesquisaGrupoMaterial, setPesquisaGrupoMaterial] = useState(0);
  const [pesquisaGrupoMaterialObjeto, setPesquisaGrupoMaterialObjeto] = useState({});
  const [fila, setFila] = useState(null);

  const [pesquisaGrupoMateriais, setPesquisaGrupoMateriais] = useState([]);

  useEffect(() => {
    const fetchPesquisaGrupoMateriais = async () => {
      const gruposMateriais = [];
      await db.pesquisaGrupoMaterial.each((grupo) => {
        gruposMateriais.push(grupo);
      });
      setPesquisaGrupoMateriais(gruposMateriais);
    };

    fetchPesquisaGrupoMateriais();
  }, []);

  const optionPesquisaGrupoMaterial = useMemo(
    () =>
      prepareForOptions(
        pesquisaGrupoMateriais?.filter((e) => e.ativo),
        ["nome"],
        "id"
      ),
    [pesquisaGrupoMateriais]
  );

  useEffect(() => {
    if (fila && pesquisaGrupoMateriais && pesquisaGrupoMateriais.length > 0) {
      setPesquisaGrupoMaterialSelect(fila);
    }

    if (pesquisaGrupoMateriais?.length > 0) {
      setPesquisaGrupoMaterialObjeto(getColumnIntoKey({ data: pesquisaGrupoMateriais, prefix: "id-" }));
    }
  }, [fila, pesquisaGrupoMateriais]);

  function setPesquisaGrupoMaterialSelect(value) {
    if (pesquisaGrupoMateriais && pesquisaGrupoMateriais.length > 0) {
      const optionGrupoProduto = (pesquisaGrupoMateriais || []).find((optGrupoProduto) => optGrupoProduto.id == value);

      if (optionGrupoProduto) {
        onChangePesquisaGrupoMaterial({
          label: optionGrupoProduto.nome,
          value: optionGrupoProduto.id,
        });
      }
      setFila(null);
    } else {
      setFila(value);
    }
  }

  function onChangePesquisaGrupoMaterial(e) {
    pesquisaGrupoMaterialSelect.upDateValue(e.value);
    pesquisaGrupoMaterialSelect.upDateDefaultValue(e || "");
    const formikInstance = formikRef?.current;
    if (formikInstance) {
      formikInstance.setFieldValue("grupoMaterialId", e.value);
      setTimeout(() => formikInstance.setFieldTouched("grupoMaterialId", true));
    }

    setPesquisaGrupoMaterial(e.value);
  }

  return {
    pesquisaGrupoMaterialObjeto,
    pesquisaGrupoMaterial,
    optionPesquisaGrupoMaterial,
    onChangePesquisaGrupoMaterial,
    pesquisaGrupoMateriais,
    pesquisaGrupoMaterialSelect,
    setPesquisaGrupoMaterial,
    setPesquisaGrupoMaterialSelect,
  };
};

export default usePesquisaGrupoMaterial;
